export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Isochrone/GPisochronOptions.png?d2df1555038b0a6136560c8fec85df6c";